import React from 'react';
import { ReactComponent as BackSVG } from './back.svg';

export default function BackIcon({width = 32, height = 32, color = 'black'})
{
  return (
    <BackSVG
      width={width}
      height={height}
      style={{color: color}}
    />
  );
}